import * as React from "react";
import { cva, type VariantProps } from "class-variance-authority";

import { cn } from "@/lib/utils";

// Small 11px labels inside agent rows and cards (Figma frames named "Pill" / "Top Match").
const nvPillVariants = cva("inline-flex items-center whitespace-nowrap rounded-nv-pill px-[10px] py-1 text-[11px] leading-[13px]", {
  variants: {
    tone: {
      // Agent type · customization ("단일 에이전트", "커스터마이징 필요")
      neutral: "bg-nv-bg-page font-medium text-nv-text-secondary",
      // "✓ Certified" in HOME rows (ver.6: orange tint, dark text)
      success: "bg-nv-brand-subtle font-bold text-nv-text-primary",
      // "★ 상위 일치" in Agent Finder results (ver.6: same orange tint)
      highlight: "bg-nv-brand-subtle font-bold text-nv-text-primary",
    },
  },
  defaultVariants: {
    tone: "neutral",
  },
});

export interface NvPillProps extends React.HTMLAttributes<HTMLSpanElement>, VariantProps<typeof nvPillVariants> {}

function NvPill({ className, tone, ...props }: NvPillProps) {
  return <span className={cn(nvPillVariants({ tone }), className)} {...props} />;
}

export { NvPill, nvPillVariants };
